import { AuthN, getConfig } from '@seek/online-identity';
import type { Identity } from '@seek/online-identity/lib-types/types';

import { getLanguage } from 'src/config';
import type { UserInfo } from 'src/types';
import { isCypressTest } from 'src/utils/cypress';

const mockSsoClient = {
  getToken: () => Promise.resolve('123'),
  getUserInfo: () =>
    Promise.resolve({
      adCentreUserId: 'test',
      email: 'test@test.com',
      firstName: 'Testy',
      lastName: 'McTestface',
      email_verified: true,
    }),
  login: () => ({}),
};

interface SsoClient {
  getToken: () => Promise<string | void>;
  getUserInfo: () => Promise<UserInfo>;
  login: () => void;
}

let authN: AuthN;
let client: SsoClient;

const getSsoClient = () => {
  if (isCypressTest()) {
    return mockSsoClient;
  }

  if (client) {
    return client;
  }

  if (!authN) {
    authN = new AuthN(getConfig('seekAnz-hirer', window.location));
  }

  const language = getLanguage();

  const login = () => {
    authN.login({
      additionalArguments: { language },
    });
  };

  client = {
    getToken: async () => {
      try {
        const token = await authN.getToken();

        return token;
      } catch (err: any) {
        if (err.error === 'login_required' || err.error === 'invalid_grant') {
          login();
        }
        throw err;
      }
    },
    getUserInfo: async (): Promise<UserInfo> => {
      let identity: Identity | null = null;
      try {
        identity = await authN.getIdentity();
      } catch (error) {
        throw new Error(`Failed to get identity. Error: ${error}`);
      }

      return {
        email: identity?.sub?.email,
        email_verified: identity?.sub?.email_verified,
      };
    },
    login,
  };

  return client;
};

export default getSsoClient;
